import React from 'react';
import styles from './grid.module.scss';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    columns?: number;
}

export function Grid({children, columns}: OwnProps) {
    return (
        <div
            className={classNames(styles.grid, {
                [styles.columns_one]: columns === 1,
                [styles.columns_two]: columns === 2,
                [styles.columns_three]: columns === 3,
                [styles.columns_four]: columns === 4,
            })}
        >
            {children}
        </div>
    );
}
